(function(){
  function h(s){let x=5381>>>0;for(let i=0;i<s.length;i++)x=((x<<5)+x+s.charCodeAt(i))>>>0;return x>>>0}
  const HX1=2784150788>>>0; // djb2('dropmeta.com.br|@eujraraujo')
  const HX2=2906025283>>>0; // djb2('sports-collections-hub|dropmeta.com.br|@eujraraujo')

  function ok(root){
    const t=document.createElement('i');t.className='dm-auth';root.appendChild(t);
    let c=getComputedStyle(t,'::before').content||'';root.removeChild(t);
    c=c.replace(/^["']|["']$/g,'');
    if(h(c)!==HX1) return false;
    if(h((root.dataset.dropmeta||'')+'|'+c)!==HX2) return false;
    return true;
  }

  function parseJSON(id){
    const el=document.getElementById(id); if(!el) return null;
    try{ return JSON.parse(el.textContent); }catch(e){ return null; }
  }

  function initials(txt){return (txt||'').split(/\s+/).map(p=>p[0]).join('').slice(0,3).toUpperCase()}
  function dedupe(arr){const s=new Set(),out=[];arr.forEach(c=>{if(!c)return;const k=String((c.handle||'')+'|'+(c.title||'')+'|'+(c.url||'')).toLowerCase();if(!s.has(k)){s.add(k);out.push(c)}});return out}
  const isDesktop=()=>matchMedia('(min-width:620px)').matches;
  const pageSize=()=>isDesktop()?8:4;

  function card(col){
    const a=document.createElement('a');
    a.className='dm-card'; a.href=col.url||('/collections/'+col.handle);
    a.setAttribute('aria-label',col.title||col.handle); a.dataset.match='1';
    const box=document.createElement('div'); box.className='dm-logo';
    if(col.image){const img=document.createElement('img');img.src=col.image;img.alt=col.title||col.handle;box.appendChild(img)}
    else{const m=document.createElement('div');m.className='dm-mono';m.textContent=initials(col.title||col.handle);box.appendChild(m)}
    const name=document.createElement('div'); name.className='dm-name'; name.textContent=col.title||col.handle;
    a.appendChild(box); a.appendChild(name);
    return a;
  }

  function buildPagination(panel){
    const grid=panel.querySelector('.dm-grid'); if(!grid) return;
    const hasTeamCards=grid.querySelector('.dm-card:not(.dm-league-card)');
    if(!hasTeamCards){ const ex=panel.querySelector('.dm-pager'); if(ex) ex.remove(); grid.querySelectorAll('.dm-card').forEach(c=>c.style.display=''); return; }
    const all=Array.from(grid.querySelectorAll('.dm-card')).filter(c=>!c.classList.contains('dm-league-card'));
    const match=all.filter(c=>c.dataset.match!=='0');
    const ps=pageSize(); const total=Math.max(1,Math.ceil(match.length/ps));
    let idx=Number(panel.dataset.pageIndex||0); if(idx>=total) idx=0; panel.dataset.pageIndex=String(idx);
    all.forEach(c=>c.style.display='none'); match.forEach((c,i)=>{ if(i>=idx*ps && i<(idx+1)*ps) c.style.display=''; });

    let ctr=panel.querySelector('.dm-pager');
    if(!ctr){
      ctr=document.createElement('div'); ctr.className='dm-pager';
      ctr.innerHTML='<button type="button" class="dm-arrow dm-prev" aria-label="Anterior">‹</button><div class="dm-dots"></div><button type="button" class="dm-arrow dm-next" aria-label="Próximo">›</button>';
      grid.after(ctr);
      ctr.querySelector('.dm-prev').addEventListener('click',()=>{let i=Number(panel.dataset.pageIndex||0); if(i>0){panel.dataset.pageIndex=String(--i); buildPagination(panel);}});
      ctr.querySelector('.dm-next').addEventListener('click',()=>{let i=Number(panel.dataset.pageIndex||0); const tp=Number(ctr.dataset.totalPages||1); if(i<tp-1){panel.dataset.pageIndex=String(++i); buildPagination(panel);}});
    }
    ctr.dataset.totalPages=String(total);
    const dots=ctr.querySelector('.dm-dots'); dots.innerHTML='';
    for(let i=0;i<total;i++){ const d=document.createElement('button'); d.className='dm-dot'; d.type='button'; d.setAttribute('aria-label','Ir para página '+(i+1)); d.setAttribute('aria-current',i===idx?'true':'false'); d.addEventListener('click',()=>{panel.dataset.pageIndex=String(i); buildPagination(panel);}); dots.appendChild(d); }
    ctr.querySelector('.dm-prev').disabled = idx===0 || match.length===0;
    ctr.querySelector('.dm-next').disabled = idx>=total-1 || match.length===0;
  }

  function renderTeamsGrid(cols){
    const host=document.createElement('div'); const grid=document.createElement('div'); grid.className='dm-grid';
    const clean=dedupe(cols||[]); if(!clean.length){const empty=document.createElement('div');empty.className='dm-empty';empty.textContent='Nenhuma coleção encontrada.';grid.appendChild(empty)} else {clean.forEach(c=>grid.appendChild(card(c)));}
    host.appendChild(grid);
    setTimeout(()=>{ const panel=host.closest('.dm-panel')||host; buildPagination(panel); },0);
    return host;
  }

  function renderLeaguesGrid(groups, leagueIcons){
    const host=document.createElement('div'); if(!groups||!groups.length){const empty=document.createElement('div'); empty.className='dm-empty'; empty.textContent='Nenhuma liga configurada.'; host.appendChild(empty); return host;}
    const title=document.createElement('h3'); title.className='dm-leagues-title'; title.textContent='As principais ligas do mundo'; host.appendChild(title);
    const grid=document.createElement('div'); grid.className='dm-grid';
    groups.forEach(g=>{
      const btn=document.createElement('button'); btn.type='button'; btn.className='dm-card dm-league-card'; btn.setAttribute('aria-label',g.label||'Liga'); btn.dataset.match='1';
      const box=document.createElement('div'); box.className='dm-logo';
      const iconSrc=g.icon || leagueIcons[g.label] || '';
      if(iconSrc){ const img=document.createElement('img'); img.src=iconSrc; img.alt=g.label; box.appendChild(img); }else{ const m=document.createElement('div'); m.className='dm-mono'; m.textContent=initials(g.label||'Liga'); box.appendChild(m); }
      const name=document.createElement('div'); name.className='dm-name'; name.textContent=g.label||'Liga';
      btn.appendChild(box); btn.appendChild(name);
      btn.addEventListener('click',()=>btn.dispatchEvent(new CustomEvent('dm:open-league',{bubbles:true,detail:g})));
      grid.appendChild(btn);
    });
    host.appendChild(grid);
    return host;
  }

  function resolveFlatTeams(s, byHandle, byTitle){
    const out=[]; const items=[]; if(Array.isArray(s.handles)) items.push(...s.handles); if(Array.isArray(s.titles)) items.push(...s.titles);
    items.forEach(id=>{let c=byHandle[id]; if(!c) c=byTitle[(id||'').toLowerCase()]; if(c) out.push(c);});
    return dedupe(out);
  }

  function applySearch(q, panelsWrap){
    const val=(q||'').trim().toLowerCase(); const active=panelsWrap.querySelector('.dm-panel[aria-hidden="false"]'); if(!active) return;
    const grid=active.querySelector('.dm-grid'); if(!grid) return;
    const thereAreTeamCards=grid.querySelector('.dm-card:not(.dm-league-card)'); const leagueView=!thereAreTeamCards && grid.querySelector('.dm-league-card')!==null;
    const cards=Array.from(grid.querySelectorAll('.dm-card')); const eligible=leagueView ? cards.filter(c=>c.classList.contains('dm-league-card')) : cards.filter(c=>!c.classList.contains('dm-league-card'));
    let matches=0; eligible.forEach(card=>{const name=(card.querySelector('.dm-name')?.textContent||'').toLowerCase(); const m=!val || name.includes(val); card.dataset.match=m?'1':'0'; if(leagueView) card.style.display=m?'':'none'; if(m) matches++;});
    let msg=grid.querySelector('.dm-empty-search'); if(matches===0){ if(!msg){ msg=document.createElement('div'); msg.className='dm-empty dm-empty-search'; msg.textContent=leagueView?'Nenhuma liga corresponde à pesquisa.':'Nenhum time corresponde à pesquisa.'; grid.appendChild(msg);} } else if(msg){ msg.remove(); }
    buildPagination(active);
  }

  function boot(root){
    if(!ok(root)) return;
    root.setAttribute('data-dm-ok','1');

    const SID=root.dataset.sectionId;
    const rail=document.getElementById('dm-sports-'+SID);
    const panels=document.getElementById('dm-panels-'+SID);
    const bc=document.getElementById('dm-bc-'+SID);
    const search=document.getElementById('dm-search-'+SID);

    const colJson=parseJSON('dm-collections-'+SID)||{items:[]};
    const cfg=parseJSON('dm-config-'+SID)||{};
    const icons=parseJSON('dm-icons-'+SID)||{};
    const leagueIcons=parseJSON('dm-league-icons-'+SID)||{};

    const byHandle={}, byTitle={};
    (colJson.items||[]).forEach(c=>{ if(!c) return; if(c.handle) byHandle[c.handle]=c; if(c.title) byTitle[(c.title||'').toLowerCase()]=c; });

    const sports=Array.isArray(cfg.sports)?cfg.sports:[];
    const isFutebol=(s)=>s.key==='Futebol';

    function renderBreadcrumb(ctx){
      bc.innerHTML=''; const label=document.createElement('span'); label.className='dm-current';
      if(ctx.league){ const back=document.createElement('button'); back.className='dm-bc-chip'; back.type='button'; back.textContent='Voltar'; back.addEventListener('click',ctx.onBack); bc.appendChild(back); bc.appendChild(document.createTextNode(' ')); label.textContent=ctx.sport+' / '+ctx.league; }
      else { label.textContent=ctx.sport; }
      bc.appendChild(label);
    }

    function buildRail(){
      rail.innerHTML='';
      sports.forEach((s,i)=>{
        const btn=document.createElement('button'); btn.className='dm-rail__btn'; btn.type='button'; btn.role='tab'; btn.dataset.key=s.key; btn.setAttribute('aria-selected',i===0?'true':'false');
        const iconBox=document.createElement('div'); iconBox.className='dm-rail__icon';
        const iconSrc=s.icon||icons[s.key]||''; if(iconSrc){ const img=document.createElement('img'); img.src=iconSrc; img.alt=s.key; iconBox.appendChild(img);} else { const m=document.createElement('div'); m.className='dm-mono'; m.textContent=initials(s.key); iconBox.appendChild(m); }
        const name=document.createElement('div'); name.className='dm-rail__name'; name.textContent=s.key;
        btn.appendChild(iconBox); btn.appendChild(name);
        btn.addEventListener('click',()=>selectSport(s.key));
        rail.appendChild(btn);
      });
    }

    function buildPanels(){
      panels.innerHTML='';
      sports.forEach((s,i)=>{
        const panel=document.createElement('div'); panel.className='dm-panel'; panel.dataset.key=s.key; panel.dataset.view=isFutebol(s)?'leagues':'teams'; panel.setAttribute('aria-hidden',i===0?'false':'true');
        if(isFutebol(s) && Array.isArray(s.groups)){ panel.appendChild(renderLeaguesGrid(s.groups, leagueIcons)); }
        else { panel.appendChild(renderTeamsGrid(resolveFlatTeams(s,byHandle,byTitle))); }
        panels.appendChild(panel);
      });
    }

    function backToLeagues(){
      const s=sports.find(isFutebol); const panel=panels.querySelector('.dm-panel[data-key="Futebol"]'); if(!s||!panel) return;
      panel.dataset.view='leagues'; panel.innerHTML=''; panel.appendChild(renderLeaguesGrid(s.groups||[], leagueIcons)); renderBreadcrumb({sport:'Futebol'}); search.value=''; applySearch('', panels);
    }

    function openLeague(group){
      const panel=panels.querySelector('.dm-panel[data-key="Futebol"]'); if(!panel) return;
      panel.dataset.view='league'; renderBreadcrumb({sport:'Futebol',league:group.label,onBack:()=>backToLeagues()});
      let list=[]; const ids=[]; if(Array.isArray(group.handles)) ids.push(...group.handles); if(Array.isArray(group.titles)) ids.push(...group.titles);
      ids.forEach(id=>{let c=byHandle[id]; if(!c) c=byTitle[(id||'').toLowerCase()]; if(c) list.push(c);}); list=dedupe(list);
      panel.innerHTML=''; panel.appendChild(renderTeamsGrid(list)); setTimeout(()=>buildPagination(panel),0); search.value=''; applySearch('', panels);
    }

    function selectSport(key){
      rail.querySelectorAll('.dm-rail__btn').forEach(b=>b.setAttribute('aria-selected', b.dataset.key===key?'true':'false'));
      panels.querySelectorAll('.dm-panel').forEach(p=>p.setAttribute('aria-hidden', p.dataset.key===key?'false':'true'));
      if(key==='Futebol'){ backToLeagues(); } else { renderBreadcrumb({sport:key}); const panel=panels.querySelector('.dm-panel[data-key="'+key+'"]'); if(panel){ setTimeout(()=>buildPagination(panel),0); } search.value=''; applySearch('', panels); }
    }

    panels.addEventListener('dm:open-league', e=>openLeague(e.detail));
    buildRail(); buildPanels();
    if(sports[0]) selectSport(sports[0].key||'Futebol');
    if(search) search.addEventListener('input', e=>applySearch(e.target.value, panels));

    let rto=null; const rebuild=()=>{const p=panels.querySelector('.dm-panel[aria-hidden="false"]'); if(p) buildPagination(p);};
    addEventListener('orientationchange',()=>{clearTimeout(rto); rto=setTimeout(rebuild,150);});
    addEventListener('resize',()=>{clearTimeout(rto); rto=setTimeout(rebuild,150);});
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.dm-hub[data-dropmeta]').forEach(boot);
  });
})();
